import { BaseMenuEntityConfiguration } from '../entityConfigs/index.js';
export default new BaseMenuEntityConfiguration({
    consumable: true,
    filters: [
        {
            name: 'popular',
            type: 'Boolean',
        },
        {
            name: 'upsell',
            type: 'Boolean',
        },
    ],
    hasDescription: true,
    hasHours: false,
    hasImage: true,
    hasVariations: true,
    hasPos: true,
    lists: [
        {
            collection: 'ModifierSet',
            name: 'modifierSets',
            primaryRelationship: true,
        },
    ],
    name: 'Item',
    options: {
        nutritionalInformation: {
            minCalories: null,
            maxCalories: null,
        },
        points: null,
        popular: false,
        slug: 'placeholder',
        upsell: false,
        experiments: undefined,
    },
    pluralizedName: 'Items',
    sellable: true,
    sortKeys: ['points'],
    unlinkedOptions: [],
    version: 19,
});
//# sourceMappingURL=item.js.map